var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { Emit, Model, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
var systemModule = namespace('system-manage');
var ResourceControl = /** @class */ (function (_super) {
    __extends(ResourceControl, _super);
    function ResourceControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceControl.prototype.emitSelectedChange = function (val) { };
    ResourceControl.prototype.emitCheckTreeNode = function () { };
    Object.defineProperty(ResourceControl.prototype, "dataSet", {
        get: function () {
            var _this = this;
            return this.systemControls.filter(function (x) { return x.parent === _this.currentTreeId; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResourceControl.prototype, "selectionList", {
        get: function () {
            var _this = this;
            return this.dataSet.filter(function (x) { return _this.selectedControlIds.includes(x.id); });
        },
        enumerable: false,
        configurable: true
    });
    ResourceControl.prototype.onSelectionListChange = function (val) {
        if (val.length)
            this.emitCheckTreeNode();
        var keySet = new Set(this.dataSet.map(function (x) { return x.id; }).concat(this.selectedControlIds));
        this.dataSet.forEach(function (item) {
            if (val.findIndex(function (x) { return x.id === item.id; }) < 0)
                keySet.delete(item.id);
        });
        this.emitSelectedChange(Array.from(keySet));
    };
    __decorate([
        systemModule.Getter
    ], ResourceControl.prototype, "systemControls", void 0);
    __decorate([
        Prop()
    ], ResourceControl.prototype, "currentTreeId", void 0);
    __decorate([
        Model('selected-change', {
            type: Array,
            default: function () { return []; }
        })
    ], ResourceControl.prototype, "selectedControlIds", void 0);
    __decorate([
        Emit('selected-change')
    ], ResourceControl.prototype, "emitSelectedChange", null);
    __decorate([
        Emit('check-tree-node')
    ], ResourceControl.prototype, "emitCheckTreeNode", null);
    ResourceControl = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], ResourceControl);
    return ResourceControl;
}(Vue));
export default ResourceControl;
